import React from 'react';
import SectionHeader from '../ui/SectionHeader';
import SKILLS from '../../data/skills';
import STATS from '../../data/stats';
import {getStatColor} from '../../utils/helpers'


import { SKILL_LEVELS_TO_ALLOCATE, MAX_LEVELS_PER_SKILL } from '../../config/gameConfig';
// ─── STEP 3: SKILLS ─────────────────────────────────────────────────────────
function SkillStep({ character, setCharacter, skillLevelsUsed, finalStats }) {
  const remaining = SKILL_LEVELS_TO_ALLOCATE - skillLevelsUsed;

  function adjustSkill(skillId, delta) {
    const current = character.skills[skillId] || 0;
    if (delta < 0 && current <= 0) return;
    if (delta > 0 && (remaining <= 0 || current >= MAX_LEVELS_PER_SKILL)) return;
    setCharacter({ ...character, skills: { ...character.skills, [skillId]: current + delta } });
  }

  return (
    <div>
      <SectionHeader>Allocate Skill Levels</SectionHeader>
      <p style={{ fontSize: "13px", color: "#8a7e5e", marginBottom: 18, lineHeight: 1.5 }}>
        Distribute <strong style={{ color: "#c9a84c" }}>10 levels</strong> across skills. No more than <strong style={{ color: "#c9a84c" }}>3 levels</strong> in any single skill at character creation. Each level adds +1 to that skill's D20 check.
      </p>
      {["might","speed","intellect"].map(statId => {
        const stat = STATS.find(s => s.id === statId);
        const modifier = Math.floor(finalStats[statId] / 10);
        return (
          <div key={statId} style={{ marginBottom: 20 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
              <div style={{ width: 8, height: 8, borderRadius: "50%", background: stat.color }} />
              <span style={{ fontFamily: "'Cinzel', serif", fontSize: "13px", color: stat.color }}>{stat.label} Skills</span>
              <span style={{ fontSize: "10px", color: "#6b6048" }}>— Stat Modifier: +{modifier} to all</span>
            </div>
            <div style={{ display: "grid", gap: 4 }}>
              {SKILLS[statId].map(skill => {
                const lvl = character.skills[skill.id] || 0;
                return (
                  <div key={skill.id} style={{ display: "flex", alignItems: "center", gap: 10, background: "rgba(20,16,10,0.4)", borderRadius: 6, padding: "7px 12px", border: "1px solid rgba(201,168,76,0.08)" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: "12px", color: "#c9a84c88" }}>{skill.name}</div>
                      <div style={{ fontSize: "10px", color: "#5a5040" }}>{skill.desc}</div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <button onClick={() => adjustSkill(skill.id, -1)} style={{ background: "none", border: "1px solid rgba(201,168,76,0.2)", color: "#8a7e5e", width: 22, height: 22, borderRadius: 3, cursor: "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>−</button>
                      {/* Level dots */}
                      <div style={{ display: "flex", gap: 3 }}>
                        {[0,1,2].map(i => (
                          <div key={i} style={{ width: 10, height: 10, borderRadius: "50%", background: i < lvl ? stat.color : "rgba(201,168,76,0.15)", border: `1px solid ${i < lvl ? stat.color : "rgba(201,168,76,0.2)"}`, transition: "all 0.15s" }} />
                        ))}
                      </div>
                      <button onClick={() => adjustSkill(skill.id, 1)} style={{ background: "none", border: "1px solid rgba(201,168,76,0.2)", color: "#8a7e5e", width: 22, height: 22, borderRadius: 3, cursor: "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SkillStep
